
import React, { useEffect } from 'react';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-32 bg-theme-bg transition-colors">
      <div className="max-w-4xl mx-auto px-6">
        <header className="mb-16">
          <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">Privacy</span>
          <h1 className="font-display text-4xl md:text-6xl text-theme-text mt-4">Privacyverklaring</h1>
        </header>

        <div className="prose prose-neutral max-w-none space-y-12">
          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3">
              <span className="text-primary text-sm font-sans font-bold">01</span> Identiteit van de verwerkingsverantwoordelijke
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Deze website wordt beheerd door:</p>
              <p>
                <strong>Dr. An De Cuyper</strong><br />
                Boniverlei 174<br />
                2650 Edegem – Antwerpen<br />
                België<br />
                Tel: +32 3 284 45 39
              </p>
              <p>
                Dr. An De Cuyper is verantwoordelijk for de verwerking van uw persoonsgegevens zoals beschreven in deze privacyverklaring.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3">
              <span className="text-primary text-sm font-sans font-bold">02</span> Welke persoonsgegevens worden verwerkt?
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Afhankelijk van uw gebruik van de website kunnen de volgende gegevens worden verwerkt:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Identiteitsgegevens (naam, voornaam)</li>
                <li>Contactgegevens (telefoonnummer, e-mailadres)</li>
                <li>Afspraak- en communicatiegegevens</li>
                <li>Technische gegevens (IP-adres, browser, toesteltype)</li>
                <li>Medische informatie (uitsluitend in het kader van een consult of behandeling)</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3">
              <span className="text-primary text-sm font-sans font-bold">03</span> Doeleinden van de verwerking
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Uw persoonsgegevens worden verwerkt voor:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>het beantwoorden van vragen of contactaanvragen;</li>
                <li>het beheren van afspraken;</li>
                <li>het verlenen van medische en esthetische zorg;</li>
                <li>het bijhouden van medische dossiers;</li>
                <li>het verbeteren van de website en dienstverlening;</li>
                <li>het naleven van wettelijke verplichtingen.</li>
              </ul>
            </div>
          </section>
          {/* ... keeping other sections with themed classes */}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
